import { SVGProps } from 'react';

export const FavouriteIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 26 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.2842 5.4715L12.4076 5.37848L12.2842 5.4715C12.455 5.69813 12.7188 5.83236 13.0001 5.83236C13.2812 5.83236 13.545 5.69814 13.7158 5.4715C14.8218 4.00419 15.9985 3.28437 17.0906 3.03235L17.0559 2.88177L17.0906 3.03235C18.1868 2.77937 19.2822 2.97806 20.2579 3.50001C22.2582 4.57024 23.5858 6.89065 23.3044 9.01655L23.4576 9.03683L23.3044 9.01656C22.9995 11.3212 21.5885 13.7114 19.5536 15.9467C17.6598 18.0271 15.2948 19.8969 13.0001 21.3463C10.7051 19.8969 8.34021 18.0271 6.44635 15.9467C4.41149 13.7114 3.00054 11.3212 2.69555 9.01656C2.41421 6.89065 3.74174 4.57024 5.74208 3.50002C6.71768 2.97806 7.81313 2.77937 8.90942 3.03235C10.0015 3.28437 11.1782 4.00419 12.2842 5.4715ZM13.0001 3.47191C11.8587 2.24462 10.5984 1.51122 9.3059 1.21295C7.74037 0.851673 6.21033 1.14796 4.9063 1.84564C2.34769 3.21454 0.498565 6.23221 0.900346 9.26822C1.27841 12.1251 2.97534 14.861 5.12414 17.2216C7.2865 19.597 9.98814 21.6823 12.5382 23.2371C12.8229 23.4108 13.177 23.4108 13.4618 23.2371C16.0119 21.6823 18.7135 19.597 20.8758 17.2216C23.0246 14.861 24.7215 12.1251 25.0997 9.26822C25.5014 6.23221 23.6523 3.21455 21.0936 1.84564C19.7896 1.14796 18.2596 0.851673 16.6941 1.21295L16.6941 1.21295C15.4016 1.51122 14.1413 2.24461 13.0001 3.47191Z"
        stroke="#282828"
        strokeWidth="0.045068"
      />
    </svg>
  );
};
